import * as React from 'react';

function SlideNavItem({ isCurrent, ...rest }): React.ReactElement {
  return (
    <li className="slide-nav-item">
      <button aria-current={isCurrent} {...rest}>
        <span />
      </button>
    </li>
  );
}

export default SlideNavItem;